import { defineComponent as _defineComponent } from 'vue'
import { computed, useContext, useStore } from '@nuxtjs/composition-api';
import { ExtendedPlan } from '~/data/plans';
import { priceFormatNoCentsIfZero } from '@/utils/price-format';
import CheckIcon from '~/components/plans/CheckIcon.vue';
import { Plan, UserSubscriptionCode } from '~/types/plan';
import { useLocale } from '~/composables/useLocale';
import { useButton } from '~/composables/components/useButton';

export interface PlanCardProps {
  currentPlan: UserSubscriptionCode | null;
  plan: ExtendedPlan;
  wide?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'PlanCard',
  props: {
    currentPlan: null,
    plan: null,
    wide: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  currentPlan: UserSubscriptionCode | null;
  plan: ExtendedPlan;
  wide?: boolean;
};

const { $isFlagOn, $mzAnalyticsApi } = useContext();


const { app, localePath } = useContext();
const $config = app.$config;
const store = useStore();
const locale = useLocale();
const deviceId = store.getters['device/id'];
const australianVersion = computed(() => locale.value === 'au');
const { classes } = useButton({ variant: 'primary' }, 'link');
const isSchoolMember = computed(() => {
  return (
    props.currentPlan === 'school_plan_member' ||
    props.currentPlan === 'school_plan_admin_only' ||
    props.currentPlan === 'school_ultimate' ||
    props.currentPlan === 'school_plan'
  );
});

const ctaText = computed(() => {
  if (props.currentPlan) {
    if (props.currentPlan === 'free' || props.plan.slug === 'plus_annual') {
      if (isSchoolMember) {
        return 'Change Plan';
      }
      return 'Upgrade';
    } else {
      return 'Change Plan';
    }
  }
  if (props.plan.title === 'School Packages') {
    return 'Enquire today';
  }

  return 'Sign Up for ' + (props.plan.title === 'Plus Monthly' ? 'Plus' : props.plan.title);
});

const isCurrentPlan = computed(() => props.currentPlan === props.plan.code);
const shouldShowPlanLink = computed(() => {
  if (props.currentPlan === 'administrator') {
    return false;
  }
  if (!props.currentPlan) {
    return true;
  }

  /**
   * https://linear.app/teachstarter/issue/LOOP-523/download-limits-or-remove-get-started-button-on-plans-page-for-free
   *
   * We cannot show to link to the free plan for logged-in users because the link is broken on v1
   */
  return !(props.currentPlan !== 'free' && props.plan.slug === 'free');
});

const isDowngrade = computed(
  () => props.currentPlan === 'teach_plus' || props.currentPlan === 'administrator'
);
const planUrl = computed<string>(() => {
  if (props.plan.slug === 'free') {
    return localePath('/signup');
  }

  if (props.plan.slug === 'school_plan') {
    return '/au/school';
  }

  if (!props.currentPlan || isDowngrade.value) {
    if ($isFlagOn('new-subscribe')) {
      return `/signup?plan=${props.plan.slug}`;
    }
    return `${$config.wpURL}/subscribe/?plan=${props.plan.slug}&amp_device_id=${deviceId}`;
  }

  return localePath('/upgrade/') + `?plan=${props.plan.slug}`;
});
const isExternalLink = computed<boolean>(() => !!planUrl.value.match(/^https?:\/\//i));
const planCardClicked = () => {
  let btnName;
  switch (props.plan.title) {
    case 'Free':
      btnName = 'upgrade.change_plan_(free)';
      break;
    case 'Plus Monthly':
      btnName = 'upgrade.change_plan_(plus)';
      break;
    case 'Essential':
      btnName = 'upgrade.change_plan_(essential)';
      break;

    default:
      btnName = `upgrade.change_plan_(${props.plan.title.toLowerCase().replace(' ', '_')})`;
      break;
  }
  $mzAnalyticsApi({
    event: 'click',
    name: btnName,
    productArea: 'profile',
  });
};

return { __sfc: true,$isFlagOn, $mzAnalyticsApi, props, app, localePath, $config, store, locale, deviceId, australianVersion, classes, isSchoolMember, ctaText, isCurrentPlan, shouldShowPlanLink, isDowngrade, planUrl, isExternalLink, planCardClicked, priceFormatNoCentsIfZero, CheckIcon }
}

})